import Vue from 'vue'

// Base components
import YBtn from '@/components/YBtn'
import YPagination from '@/components/YPagination'
import YPaginationCustom from '@/components/YPaginationCustom'
import YDialog from '@/components/YDialog'
import YBottomSheet from '@/components/YBottomSheet'
import YSwitch from '@/components/YSwitch'
import YCheckbox from '@/components/YCheckbox'
import YStepper from '@/components/YStepper'
import YSchedulePicker from '@/components/YSchedulePicker'
import YPhoneInput from '@/components/YPhoneInput'
import YSelect from '@/components/YSelect'
import YButton from '@/components/YButton'
import YChip from '@/components/YChip'

// Connect custom components
import YcSelect from '@/components/connect/custom/YcSelect'
import YcTextArea from '@/components/connect/custom/YcTextArea'
import YcTextField from '@/components/connect/custom/YcTextField'
import YcCheckbox from '@/components/connect/custom/YcCheckbox'
import YcDatePicker from '@/components/connect/custom/YcDatePicker'
import YcAutocomplete from '@/components/connect/custom/YcAutocomplete'
import YcPagination from '@/components/connect/custom/YcPagination'
import YcPaginationCustom from '@/components/connect/custom/YcPaginationCustom'
import YcPhoneInput from '@/components/connect/custom/YcPhoneInput'

// YZ custom components
import { VIcon, VListItem, VCardText, VCardActions, VCardTitle, VCardSubtitle, VImg, VAvatar, VResponsive, VSkeletonLoader, VChip, VProgressLinear, VProgressCircular } from 'vuetify/lib/components'
import YzBtn from '@/components/yds/YzBtn.vue'
import YzRadio from "@/components/yds/YzRadio.vue"
import YzRadioGroup from "@/components/yds/YzRadioGroup.vue"
import YzCheckbox from "@/components/yds/YzCheckbox.vue"
import YzCheckboxGroup from "@/components/yds/YzCheckboxGroup.vue"
import YzSwitch from "@/components/yds/YzSwitch.vue"
import YzPagination from '@/components/yds/YzPagination.vue'
import YzTruncatedList from '@/components/yds/YzTruncatedList.vue'
import YzTextField from "@/components/yds/YzTextField.vue"
import YzTextarea from "@/components/yds/YzTextarea.vue"
import YzMenu from "@/components/yds/YzMenu.vue"
import YzList from "@/components/yds/YzList.vue"
import YzDivider from "@/components/yds/YzDivider.vue"
import YzCard from "@/components/yds/YzCard.vue"
import YzEmptyStateCard from "@/components/yds/YzEmptyStateCard.vue"
import YzBadge from "@/components/yds/YzBadge.vue"
import YzDot from "@/components/yds/YzDot.vue"
import YzDialog from "@/components/yds/YzDialog.vue"
import YzDialogFullscreenHeader from "@/components/yds/YzDialogFullscreenHeader.vue"
import YzDialogFullscreenContent from "@/components/yds/YzDialogFullscreenContent.vue"
import YzDialogNormalHeader from "@/components/yds/YzDialogNormalHeader.vue"
import YzDialogNormalActions from "@/components/yds/YzDialogNormalActions.vue"
import YzRadioSelectionCard from "@/components/yds/YzRadioSelectionCard.vue"
import YzCheckboxSelectionCard from "@/components/yds/YzCheckboxSelectionCard.vue"
import YzTooltip from "@/components/yds/YzTooltip.vue"
import YzDropdown from "@/components/yds/YzDropdown.vue"
import YzApiDropdown from "@/components/yds/YzApiDropdown.vue"
import YzPhoneInput from "@/components/yds/YzPhoneInput.vue"
import YzUploadButton from "@/components/yds/YzUploadButton.vue"
import YzUploadCard from "@/components/yds/YzUploadCard.vue"
import YzBtnToggle from "@/components/yds/YzBtnToggle.vue"
import YzUploadQrDatabin from "@/components/yds/YzUploadQrDatabin.vue"
import YzDatabinSync from "@/components/yds/YzDatabinSync.vue"
import YzFilePreview from "@/components/yds/YzFilePreview.vue"
import YzDeleteConfirmationDialog from "@/components/yds/YzDeleteConfirmationDialog.vue"
import YzTabs from "@/components/yds/YzTabs.vue"
import YzTab from "@/components/yds/YzTab.vue"
import YzDataTable from "@/components/yds/YzDataTable.vue"
import YzSimpleTable from "@/components/yds/YzSimpleTable.vue"
import YzAddressInput from "@/components/yds/YzAddressInput.vue"
import YzSearchBtn from "@/components/yds/YzSearchBtn.vue"
import YzDataTableSorter from "@/components/yds/YzDataTableSorter.vue"
import YzDatePicker from "@/components/yds/YzDatePicker.vue"
import YzFilterMenu from "@/components/yds/YzFilterMenu.vue"

const YzComponent = {
  install() {
    // Base components
    Vue.component('y-btn', YBtn)
    Vue.component('y-dialog', YDialog)
    Vue.component('y-bottom-sheet', YBottomSheet)
    Vue.component('y-switch', YSwitch)
    Vue.component('y-checkbox', YCheckbox)
    Vue.component('y-pagination', YPagination)
    Vue.component('y-pagination-custom', YPaginationCustom)
    Vue.component('y-stepper', YStepper)
    Vue.component('y-schedule-picker', YSchedulePicker)
    Vue.component('y-phone-input', YPhoneInput)
    Vue.component('y-select', YSelect)
    Vue.component('y-button', YButton)
    Vue.component('y-chip', YChip)

    // Custom components
    Vue.component('yc-select', YcSelect)
    Vue.component('yc-text-area', YcTextArea)
    Vue.component('yc-text-field', YcTextField)
    Vue.component('yc-checkbox', YcCheckbox)
    Vue.component('yc-date-picker', YcDatePicker)
    Vue.component('yc-autocomplete', YcAutocomplete)
    Vue.component('yc-pagination', YcPagination)
    Vue.component('yc-pagination-custom', YcPaginationCustom)
    Vue.component('yc-phone-input', YcPhoneInput)

    // YZ custom components
    Vue.component('yz-btn', YzBtn)
    Vue.component('yz-text-field', YzTextField)
    Vue.component('yz-textarea', YzTextarea)
    Vue.component('yz-icon', VIcon)
    Vue.component('yz-radio', YzRadio)
    Vue.component('yz-menu', YzMenu)
    Vue.component('yz-radio-group', YzRadioGroup)
    Vue.component('yz-checkbox', YzCheckbox)
    Vue.component('yz-checkbox-group', YzCheckboxGroup)
    Vue.component('yz-switch', YzSwitch)
    Vue.component('yz-list', YzList)
    Vue.component('yz-list-item', VListItem)
    Vue.component('yz-divider', YzDivider)
    Vue.component('yz-pagination', YzPagination)
    Vue.component('yz-truncated-list', YzTruncatedList)
    Vue.component('yz-card', YzCard)
    Vue.component('yz-card-text', VCardText)
    Vue.component('yz-card-actions', VCardActions)
    Vue.component('yz-card-title', VCardTitle)
    Vue.component('yz-card-subtitle', VCardSubtitle)
    Vue.component('yz-empty-state-card', YzEmptyStateCard)
    Vue.component('yz-badge', YzBadge)
    Vue.component('yz-dot', YzDot)
    Vue.component('yz-dialog', YzDialog)
    Vue.component('yz-dialog-fullscreen-header', YzDialogFullscreenHeader)
    Vue.component('yz-dialog-fullscreen-content', YzDialogFullscreenContent)
    Vue.component('yz-dialog-normal-header', YzDialogNormalHeader)
    Vue.component('yz-dialog-normal-content', VCardText)
    Vue.component('yz-dialog-normal-actions', YzDialogNormalActions)
    Vue.component('yz-radio-selection-card', YzRadioSelectionCard)
    Vue.component('yz-checkbox-selection-card', YzCheckboxSelectionCard)
    Vue.component('yz-tooltip', YzTooltip)
    Vue.component('yz-dropdown', YzDropdown)
    Vue.component('yz-api-dropdown', YzApiDropdown)
    Vue.component('yz-phone-input', YzPhoneInput)
    Vue.component('yz-upload-button', YzUploadButton)
    Vue.component('yz-upload-card', YzUploadCard)
    Vue.component('yz-upload-qr-databin', YzUploadQrDatabin)
    Vue.component('yz-databin-sync', YzDatabinSync)
    Vue.component('yz-file-preview', YzFilePreview)
    Vue.component('yz-delete-confirmation-dialog', YzDeleteConfirmationDialog)
    Vue.component('yz-tabs', YzTabs)
    Vue.component('yz-tab', YzTab)
    Vue.component('yz-img', VImg)
    Vue.component('yz-avatar', VAvatar)
    Vue.component('yz-responsive', VResponsive)
    Vue.component('yz-btn-toggle', YzBtnToggle)
    Vue.component('yz-data-table', YzDataTable)
    Vue.component('yz-skeleton-loader', VSkeletonLoader)
    Vue.component('yz-chip', VChip)
    Vue.component('yz-simple-table', YzSimpleTable)
    Vue.component('yz-address-input', YzAddressInput)
    Vue.component('yz-search-btn', YzSearchBtn)
    Vue.component('yz-data-table-sorter', YzDataTableSorter)
    Vue.component('yz-progress-linear', VProgressLinear)
    Vue.component('yz-progress-circular', VProgressCircular)
    Vue.component('yz-date-picker', YzDatePicker)
    Vue.component('yz-filter-menu', YzFilterMenu)
  }
}

export default YzComponent
